import React from "react";

const en_astara = {
  HI: "Hello!",
  INVITATION_MSG:
    "Complete the following steps to finance your vehicle at Astara Store!",
  WHAT_WILL_YOU_NEED: "What will you need?",
  DOCUMENT_RECOMMENDATION: "To complete your application you need to:",
  DNI_OR_NIE: "Identify yourself with your ID or NIE",
  IMAGE_ID_NIE_EU:
    "Image of the passport or front side of the identity document",
  PASSPORT_FRONT:
    "Photo bio page of the passport or front side of the identity document",
  NIE_EU_PASSPORT:
    "If you have a European NIE without a photo, we will also ask for your passport or front side of your national identity document",
  SPANISH_ACCOUNT: "Provide documentation",
  INCOME: "Provide documentation",
  SPANISH_ACCOUNT_DETAIL:
    "We will ask you for a series of documents to verify your financial situation before proceeding to sign the contract.",
  CONGRATULATIONS: "You are now identified!",
  CONGRATULATIONS_SIGNATURE_NOT_AVAILABLE: "Documentation provided",
  CONGRATULATION_DOCUMENTS_UPLOADED: "Documentation provided",
  CONGRATULATIONS_APPROVED_END: "Congratulations!",
  THANKS_DOCUMENTATION_UPLOADED:
    "We will verify that everything is correct to sign the contract.",
  APPLICATION_PENDING_APPROVAL:
    "We will verify that everything is correct to sign the contract",
  SIGNATURE_MODULE_YET_NOT_AVAILABLE: (
    <>
      <p>
        Once verified, we will get in touch with you to discuss the details of
        the offer and sign the contract.
      </p>
      <p>Thank you very much for your trust.</p>
    </>
  ),
  PENDING_LENDER_APPROVAL: (
    <>
      <p>
        The financial institution is analyzing your documentation and
        considering the proposal.
      </p>
      <p>
        We will inform you via email as soon as we have a definitive response
        from the financial institution.
      </p>
    </>
  ),
  THANKS_LOAN_FORM_COMPLETED: "Please complete now the following actions",
  DOCS_COMPLETED: "Documentation provided",
  LOAN_ANALYSING: "Thank you very much for your trust.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT:
    "Now you just have to complete the following actions",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED: (
    <>
      <p>
        The documentation has been provided correctly. We will verify that
        everything is correct to sign the contract.
      </p>
    </>
  ),
};

export default en_astara;
